
import React from "react";
import { ElfScene, SceneGeneratorTheme } from "./types";
import { getThemeClasses } from "./SceneGeneratorTheme";
import ItemsList from "./ItemsList";
import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";

interface SceneResultsProps {
  scene: ElfScene;
  onTryAgain: () => void;
  theme?: SceneGeneratorTheme;
}

const SceneResults: React.FC<SceneResultsProps> = ({ 
  scene, 
  onTryAgain,
  theme = "default" 
}) => {
  const themeClasses = getThemeClasses(theme);

  return (
    <div className={`border rounded-lg p-4 ${themeClasses.card}`}>
      <div className="space-y-4">
        <div>
          <h2 className="text-xl font-bold mb-1">{scene.title}</h2>
          <div className="flex flex-wrap gap-2 mb-3">
            <span className="inline-block text-xs px-2 py-1 rounded-full bg-gray-100">
              {scene.difficulty}
            </span>
            {scene.time_required && (
              <span className="inline-block text-xs px-2 py-1 rounded-full bg-gray-100">
                {scene.time_required}
              </span>
            )}
          </div>
          <p className="text-gray-700">{scene.description}</p>
        </div>

        <ItemsList items={scene.required_items} theme={theme} />

        <div>
          <h3 className="font-medium text-lg mb-2">Setup Instructions:</h3>
          <div className="bg-white border border-gray-200 rounded-md p-3">
            <p className="whitespace-pre-line">{scene.setup_instructions}</p>
          </div>
        </div>

        <div className="pt-2">
          <Button 
            onClick={onTryAgain}
            variant="outline"
            className={`w-full flex items-center justify-center gap-2 ${themeClasses.secondaryButton}`}
          >
            <RefreshCw className="h-4 w-4" />
            Spin Again
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SceneResults;
